import React, { useLayoutEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Animated,
  Easing,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../Utils/responsive";
import "../../../App.scss";
import Thirdpage from "./page3";
const actualWidth = Dimensions.get("screen").width;
const Index = (props) => {
  const [infopage, setInfopage] = useState(false);
  const [metaindex, setMetaIndex] = useState(null);
  const introAnimation = useRef(new Animated.Value(actualWidth)).current;
  useLayoutEffect(() => {
    Animated.timing(introAnimation, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false,
      easing: Easing.linear,
    }).start();
  }, []);

  const nextFunction = (index) => {
    setMetaIndex(index);
    if (
      props.moduleObject.questions[props.moduleIndex].answers[index].metadata
    ) {
      setInfopage(true);
    } else {
      props.pageTwo();
    }
    props.selectAnswerHandler(
      props.moduleObject.moduleid,
      props.moduleObject.questions[props.moduleIndex].qid,
      props.moduleObject.questions[props.moduleIndex].answers[index].respid
    );
  };

  return (
    <>
      {infopage ? (
        <Thirdpage {...props} setInfopage={setInfopage} metaindex={metaindex} />
      ) : (
        <Animated.View
          style={[
            styles.content,
            { transform: [{ translateX: introAnimation }] },
          ]}
        >
          <Text style={styles.customText}>
            {props.moduleObject.questions[props.moduleIndex].text}
          </Text>
          <View style={styles.line} />
          {props.moduleObject.questions[props.moduleIndex].answers.map(
            (data, index) => {
              return (
                <TouchableOpacity
                  style={styles.button}
                  onPress={() => nextFunction(index)}
                  key={index}
                >
                  <Text style={styles.buttontext}>{data.text}</Text>
                </TouchableOpacity>
              );
            }
          )}
        </Animated.View>
      )}
    </>
  );
};
export default Index;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },

  customText: {
    position: "relative",
    width: "75%",
    fontSize: "var(--module-detail-font-size)",
    textAlign: "center",
    color: "var(--text-color-default)",
    marginBottom: 28,
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--module-detail-letter-spacing)",
  },
  button: {
    backgroundColor: "var(--button-background-color-default)",
    width: "var(--button-long-width)",
    marginBottom: 28,
    justifyContent: "center",
    borderRadius: 2,
    elevation: 2,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 2,
    paddingTop: 2,
    paddingBottom: 2,
  },
  buttontext: {
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: "var(--button-long-font-size)",
    textAlign: "center",
    letterSpacing: "var(--button-long-letter-spacing)",
    textTransform: "uppercase",
    textShadowColor: "rgba(0, 0, 0, 0.5)",
    textShadowOffset: { width: 0, height: 1 },
    padding: 5,
  },
  line: {
    width: "75%",
    maxWidth: 660,
    height: 1,
    backgroundColor: "#d4d4d4",
    marginBottom: hp("4%"),
  },
});
